export const COUNTERS = [
    {
        text: "Experienced as <br /> Front-End Developer"
    },
    {
        count: 2,
        text: "Projects<br />Completed"
    }
]